<template>
  <div class="why-us-section__wrapper">
    <h2 class="why-us-section__title subtitle-1">WHY US</h2>

    <p class="why-us-section__description text-body">
      Finance Magnates Group isn't just a regular portal – it's a central hub
      for the fintech universe. It provides an unmatched platform for
      interaction and exposure, both in the digital and physical realms. This
      exclusive ecosystem facilitates a degree of involvement and influence
      that's really unparalleled in the sector.
    </p>

    <homepage-why-us-section-list />

    <a-visibility show :from="$breakpoint.desktopMd">
      <rotatable-svg-element-on-scroll
        :icon="$options.consts.ICON.BACKGROUND_SHAPE_1"
        :animated-data-ids="$options.consts.ANIMATED_DATA_IDS"
        class="why-us-section__background-shape"
      />
    </a-visibility>
  </div>
</template>

<script>
import { ICON } from 'shared/AIcon/index.vue'
import { ANIMATED_ELEMENT_DATA_ID } from 'enums/animated-background-shape-id'
import HomepageWhyUsSectionList from '@/components/_homepage/HomepageWhyUsSection/HomepageWhyUsSectionList/index.vue'
import RotatableSvgElementOnScroll from '@/components/_homepage/shared/RotatableSvgElementOnScroll/index.vue'
import { generateServerCacheKey } from '@/plugins/helper'

export default {
  name: 'HomepageWhyUsSection',
  serverCacheKey: () => generateServerCacheKey('HomepageWhyUsSection'),
  components: {
    RotatableSvgElementOnScroll,
    HomepageWhyUsSectionList
  },
  consts: {
    ICON,
    ANIMATED_DATA_IDS: [ANIMATED_ELEMENT_DATA_ID.SHAPE_1]
  }
}
</script>

<style lang="scss" scoped>
.why-us-section__wrapper {
  position: relative;

  .why-us-section__description {
    $margin-top: (
      $above-desktop-xl: 40px,
      $desktop-sm: 10px,
      $mobile: 14px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .why-us-section__background-shape {
    position: absolute;
    top: -57px;
    right: -#{$padding-x-desktop-full-hd};
    height: 573px;
    width: 287px;
  }
}
</style>
